import { Controller } from '@hotwired/stimulus'

// Guards a form submit with a native confirmation dialog (the app does not use
// Turbo, so data-turbo-confirm is unavailable). Attach to a form:
//   data-controller="confirm" data-confirm-message="…" data-action="submit->confirm#check"
export default class extends Controller<HTMLElement> {
  check(event: Event): void {
    const message = this.element.getAttribute('data-confirm-message') || 'Are you sure?'
    if (!window.confirm(message)) event.preventDefault()
  }
}
